<template>
  <div class="tour-compass-wrapper">
    <eg-button
      type="ordinary"
      icon="compass"
      icon-size="medium"
      :disabled="isRunning"
      :class="[
        'tour-compass-button',
        { 'tour-compass-button--active': isActive },
      ]"
      @click="onClick"
    />
    <!-- TODO: replace with a proper tooltip once Bootstrap-Vue is swapped out (v-b-tooltip arrow centering is broken near viewport edges) -->
    <div class="tour-compass-hint">
      {{ $t("common.guidedTourHint") }}
    </div>
  </div>
</template>

<script>
import { getTourContextStatus } from "@/init/onboarding/tourContexts.js";
import { runTourContext } from "@/init/onboarding/onboardings.js";

export default {
  name: "TourCompassButton",

  props: {
    context: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isRunning: false,
      clerkOnboardings:
        this.$getClerk()?.user?.unsafeMetadata?.onboardings || {},
    };
  },

  computed: {
    isActive() {
      return (
        getTourContextStatus(this.context, this.clerkOnboardings) === "active"
      );
    },
  },

  mounted() {
    this._syncOnboardings = () => {
      this.clerkOnboardings =
        this.$getClerk()?.user?.unsafeMetadata?.onboardings || {};
    };
    this.$eventBus.$on("onboarding:completed", this._syncOnboardings);
    this.$eventBus.$on("onboarding:reset", this._syncOnboardings);
  },

  beforeDestroy() {
    this.$eventBus.$off("onboarding:completed", this._syncOnboardings);
    this.$eventBus.$off("onboarding:reset", this._syncOnboardings);
  },

  methods: {
    async onClick() {
      if (this.isRunning) {
        return;
      }
      this.isRunning = true;
      try {
        // runTourContext emits onboarding:reset → _syncOnboardings fires automatically
        await runTourContext(this.context);
      } finally {
        this.isRunning = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tour-compass-wrapper {
  position: relative;
  display: inline-flex;

  &:hover .tour-compass-hint {
    opacity: 1;
  }
}

.tour-compass-hint {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease;
  z-index: 1070;

  padding: 4px 8px;
  border-radius: 8px;
  background: var(--color-surface-primary-dark);
  color: var(--color-text-on-surface-disabled);
  font-size: var(--typography-font-size-fs-300);

  &::before {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-bottom-color: var(--color-surface-primary-dark);
  }
}

.tour-compass-button {
  color: var(--color-text-neutral-secondary);

  &--active {
    color: var(--color-surface-primary-default);
  }
}
</style>
